var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var XFilledIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 64,
    glyphHeight: 64
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64ZM28.5072 33.5123L16.4097 17.3369H25.7335L33.6644 27.9412L43.48 17.3369H46.2199L34.8885 29.5784L47.6666 46.6636H38.3429L29.7313 35.1495L19.0732 46.6636H16.3333L28.5072 33.5123ZM24.7222 19.3551H20.4389L39.3535 44.6452H43.6369L24.7222 19.3551Z"
  }));
};
export var XFilledIconGlyph = function (props) {
  return React.createElement(XFilledIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};